import {sum, values} from 'lodash/fp'
import React, {Component} from 'react'

import {countriesById} from '../../data/countries'
import Button from '../../components/Button'
import Checkout from '../../components/Checkout'

import {MonthPreamble, YearPreamble, Crowdrise, WhereGoes} from './preambles'
import './styles.css'

const PER_TONNE = 25

class Payment extends Component {
  render() {
    const {country, emissions, onJointFiling, showJoint} = this.props
    const usa = country === 'US'

    const co2 = usa ? sum(values(emissions)) : countriesById[country].co2
    const cost = co2 * PER_TONNE
    const monthly = (cost / 12)
    const annual = (cost * .9)

    return (
      <div className="payment">
        <Checkout
          preamble={MonthPreamble}
          label="Your Monthly Amount"
          amount={monthly.toFixed(2)}
          caption={Crowdrise}
          co2={co2}
          type='single_monthly'
          monthly={true}
        />
        <Checkout
          preamble={YearPreamble}
          label="One-time Annual Amount"
          amount={annual.toFixed(2)}
          caption="10% Credit"
          co2={co2}
          type='single_annual'
        />
        <WhereGoes />
        {showJoint && 
          <div className="payment-buffered payment-explanation">
            <div className="payment-explanation-header">File Jointly!</div>
            <div className="payment-explanation-text">
              If you want to offset the climate impact for your entire household, you can file jointly.
              This will use your personal impact as a basis to estimate the total impact for all residents in your home.
              Together your family will help fund key forest and ocean conservation projects.
            </div>
            <Button className="payment-btn" onClick={onJointFiling}>Learn More</Button>
          </div>
        }
      </div>
    )
  }
}

export default Payment



// WEBPACK FOOTER //
// ./src/apps/Payment/Single.js